import { render, staticRenderFns } from "./DreamPDF.vue?vue&type=template&id=79c01428&scoped=true&"
import script from "./DreamPDF.vue?vue&type=script&lang=js&"
export * from "./DreamPDF.vue?vue&type=script&lang=js&"
import style0 from "./DreamPDF.vue?vue&type=style&index=0&id=79c01428&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79c01428",
  null
  
)

export default component.exports